// Shared context object and types — no React component, no JSX.
// Kept in a plain .ts file so use-auth.ts can import it without triggering
// the react-refresh/only-export-components rule on auth.tsx.

import { createContext } from "react";

// AuthUser mirrors components["schemas"]["AuthUser"] from src/api/schema.d.ts.
// Defined here as a plain interface so shared/auth has no dependency on the
// `api` boundary element (enforced by eslint-plugin-boundaries).
export interface AuthUser {
  id: string;
  email: string;
  display_name: string;
  roles: string[];
  permissions: string[];
  must_change_password: boolean;
}

export interface AuthState {
  token: string | null;
  user: AuthUser | null;
  isAuthenticated: boolean;
  status: "pending" | "authenticated" | "unauthenticated";
}

export interface AuthContextValue extends AuthState {
  login: (token: string, expiresAt: string, user: AuthUser) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
